export default __webpack_public_path__ + "static/media/ic_glp_40.933f9b97.svg";